import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { isOnFreeStageSelector, isCurrentSubscriptionLoadedSelector } from 'features/billing'
import { useWasInNotetakerIntroExperiment } from 'hooks/growth_experiments/use-was-in-notetaker-intro-experiment'

import { WIZARD_MODAL_SEEN_MAX, SESSION_KEY, MR_ONBOARDING_WIZARD } from '../constants'
import { showAcknowledgementModal } from '../modals/wizard_acknowledgement_modal/acknowledgement_modal_slice'
import { getAcknowledgementModalIsUserTriggered } from '../selectors'


export const useShouldDisplayOnboardingWizard = (MiUserDataLoading, MiUserData, update) => {
  const dispatch = useDispatch()
  const ref = useRef()
  const isCurrentSession = sessionStorage.getItem(SESSION_KEY) === 'true'
  const isUserTriggered = useSelector(getAcknowledgementModalIsUserTriggered)
  const wasInNotetakerIntroExperiment = useWasInNotetakerIntroExperiment()
  const isFreeUser = useSelector(isOnFreeStageSelector)
  const isCurrentSubscriptionLoaded = useSelector(isCurrentSubscriptionLoadedSelector)

  useEffect(() => {
    if (!ref.current && !MiUserDataLoading) {
      const attemptsRemaining = MiUserData?.onboardingWizardModalSeenCount

      if (isUserTriggered || isCurrentSession) {
        ref.current = true
        return
      }

      if (wasInNotetakerIntroExperiment) {
        ref.current = true
        return
      }

      // Prevent modal from showing if admin has disabled notetaker for the organization
      if (MiUserData?.adminDisabledNotetaker) {
        ref.current = true
        return
      }

      if (attemptsRemaining === 0 || MiUserData?.miEnabled) {
        ref.current = true
        return
      }

      if (isCurrentSubscriptionLoaded && isFreeUser) {
        // Do not set ref.current so that it can be re-evaluated
        // after a potential upgrade by the user
        return
      }

      // Users first time going through the flow - true
      if (!Number.isInteger(attemptsRemaining)) {
        update({ onboardingWizardModalSeenCount: WIZARD_MODAL_SEEN_MAX })
        ref.current = true
        sessionStorage.setItem(SESSION_KEY, 'true')
        dispatch(showAcknowledgementModal(MR_ONBOARDING_WIZARD.AUTO_LOAD))
        return
      }

      // show modal and decrement
      if (attemptsRemaining > 0) {
        update({ onboardingWizardModalSeenCount: attemptsRemaining - 1 })
        sessionStorage.setItem(SESSION_KEY, 'true')
        ref.current = true
        dispatch(showAcknowledgementModal(MR_ONBOARDING_WIZARD.AUTO_LOAD))
      }
    }
  }, [
    MiUserData,
    MiUserDataLoading,
    ref,
    isCurrentSession,
    update,
    dispatch,
    isUserTriggered,
    wasInNotetakerIntroExperiment,
    isCurrentSubscriptionLoaded,
    isFreeUser
  ])
}
